import { createMultiStyleConfigHelpers as e } from "@chakra-ui/react";
const t = e(["container"]), o = t.defineMultiStyleConfig({
  baseStyle: {
    container: {
      bg: "white",
      borderRadius: "lg",
      p: { base: 4, md: "40px" }
    }
  },
  variants: {},
  defaultProps: {}
});
export {
  o as default
};
